import { render } from "./PasswordList.vue?vue&type=template&id=0a23e710&scoped=true&ts=true"
import script from "./PasswordList.vue?vue&type=script&lang=ts"
export * from "./PasswordList.vue?vue&type=script&lang=ts"

import "./PasswordList.vue?vue&type=style&index=0&id=0a23e710&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a23e710"]])

export default __exports__